import React, { useEffect, useRef } from "react";
import "./exclusivebenefits.css";
import { FaTruckFast } from "react-icons/fa6";
import { MdMoneyOff } from "react-icons/md";
import { MdMenuBook } from "react-icons/md";
import { FaUniversity } from "react-icons/fa";
import { FaBoxes } from "react-icons/fa";

const benefits = [
  { icon: FaTruckFast, text: "Diversas alternativas de envíos", accent: "blue" },
  { icon: MdMoneyOff, text: "Promociones y dinámicas frecuentes", accent: "orange" },
  { icon: MdMenuBook, text: "Manuales y guías instructivas en línea", accent: "blue" },
  { icon: FaBoxes, text: "Kits personalizados para tus proyectos", accent: "orange" },
  { icon: FaUniversity, text: "Alianzas con instituciones educativas", accent: "blue" },
];

const ExclusiveBenefits = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("slide-in"); // Agrega la animación
          } else {
            entry.target.classList.remove("slide-in"); // La quita al salir de pantalla
          }
        });
      },
      { threshold: 0.1 } // Se activa cuando el 10% del componente es visible
    );

    const element = containerRef.current;
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element); // Limpieza
      }
    };
  }, []);

  return (
    <div className="benefits-container" ref={containerRef}>
      <span className="benefits-eyebrow" />
      <h1 className="benefits-title">Volteon: Una experiencia única</h1>
      <div className="benefits-grid">
        {benefits.map(({ icon: Icon, text, accent }) => (
          <div className={`benefit-card benefit-card--${accent}`} key={text}>
            <span className="benefit-icon-badge">
              <Icon />
            </span>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExclusiveBenefits;
